module.exports = __webpack_public_path__ + "img/dsci0132.a1656807.jpg";